import { useState } from "react";
import { Input, Button, message } from "antd";
import { user as userService } from "@/services";
function CodeInput({
  value,
  onChange,
  readyPost,
  phoneNumber,
  token,
  ...props
}) {
  const [lastTime, setLastTime] = useState(0);

  const counting = (time = 60) => {
    if (time < 0) return;
    setLastTime(time);
    setTimeout(() => {
      counting(time - 1);
    }, 1000);
  };

  return (
    <div
      style={{ display: "inline-flex", width: "100%", alignItems: "center" }}
    >
      <Input
        {...props}
        style={{ marginRight: 5, ...props.style }}
        value={value}
        onChange={onChange}
      />
      <div
        style={{
          flexShrink: 0,
          color: "#999",
          width: 100,
          height: 35,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {lastTime === 0 && (
          <Button
            disabled={!readyPost}
            block
            onClick={() => {
              if (phoneNumber) {
                userService
                  .sendCode({ phone: phoneNumber }, token.token)
                  .then((res) => {
                    if (res.result === "success") {
                      message.info("验证码已发送，请注意查收");
                      counting();
                    }
                  });
              }
            }}
          >
            发送验证码
          </Button>
        )}
        {lastTime > 0 && <span>剩余{lastTime}秒</span>}
      </div>
    </div>
  );
}

export default CodeInput;
